type PlanPill = { kind: 'hidden' } | { kind: 'known'; name: string; free: boolean } | { kind: 'unknown' };

/** What the topbar's plan pill title says when the plan could not be read. */
export const PLAN_UNKNOWN_TITLE = "Plan unknown: couldn't load it";

/** The attributes of the unknown pill: its words are the title and the accessible name. */
export function unknownPillProps(): { title: string; 'aria-label': string } {
  return { title: PLAN_UNKNOWN_TITLE, 'aria-label': PLAN_UNKNOWN_TITLE };
}

/**
 * What the topbar shows for the account's plan. No WAAP service, or a package still loading or not set: nothing. A package we
 * hold: its name, also when a later refetch failed (the last known plan beats a dash). A failed first read: a neutral dash,
 * never an empty topbar that looks like "no plan".
 */
export function planPill(input: {
  hasService: boolean;
  packageId: string | undefined;
  isError: boolean;
  planName: (packageId: string) => string;
}): PlanPill {
  if (!input.hasService) return { kind: 'hidden' };
  if (input.packageId) {
    const name = input.planName(input.packageId);
    return { kind: 'known', name, free: name.toLowerCase() === 'free' };
  }
  return input.isError ? { kind: 'unknown' } : { kind: 'hidden' };
}
